import maddyApi from '@/services/maddyApi';

const errorHandler = e => {
  if (e.response) {
    return e.response;
  } else if (e.request) {
    return e.request;
  } else {
    return e;
  }
};

export default {
  namespaced: true,
  state: {
    loading: false,
    list: null,
  },
  getters: {
    current: state => {
      return state.list[0];
    },
  },
  actions: {
    async getStudies({ commit }, filter) {
      commit('SET_LOADING', true);
      let query = '';
      if (filter) {
        const entries = Object.entries(filter);
        entries.forEach((val, index) => {
          const prepend = index === 0 ? '?' : '&';
          query += `${prepend}${val[0]}=${val[1]}`;
        });
      }
      try {
        const response = await maddyApi.get(`/studies${query}`);
        commit('SET_STUDIES', response.data);
      } catch (error) {
        return errorHandler(error);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async getStudy(context, id) {
      const endpoint = `/studies/${id}`;
      try {
        const response = await maddyApi.get(endpoint);
        return response.data;
      } catch (err) {
        return errorHandler(err);
      }
    },
    async patchStudy({ commit }, payload) {
      commit('SET_LOADING', true);
      const endpoint = `/studies/${payload.id}`;
      try {
        const response = await maddyApi.patch(endpoint, payload.study);
        return response.data;
      } catch (err) {
        return errorHandler(err);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async publishStudy({ commit }, payload) {
      commit('SET_LOADING', true);
      const endpoint = `/studies/${payload}/publish`;
      try {
        const response = await maddyApi.post(endpoint);
        return response.data;
      } catch (err) {
        return errorHandler(err);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async unpublishStudy({ commit }, payload) {
      commit('SET_LOADING', true);
      const endpoint = `/studies/${payload}/unpublish`;
      try {
        const response = await maddyApi.patch(endpoint);
        return response.data;
      } catch (err) {
        return errorHandler(err);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async deleteStudy({ commit }, payload) {
      commit('SET_LOADING', true);
      const endpoint = `/studies/${payload}`;
      try {
        const response = await maddyApi.delete(endpoint);
        return response.data;
      } catch (err) {
        return errorHandler(err);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async postStudy({ commit }, payload) {
      commit('SET_LOADING', true);
      try {
        const response = await maddyApi.post('/studies', payload);
        commit('ADD_STUDY', response.data);
        return response.data;
      } catch (error) {
        return errorHandler(error);
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
  mutations: {
    ADD_STUDY(state, payload) {
      state.list.push(payload);
    },
    SET_STUDIES(state, payload) {
      state.list = payload.data;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
  },
};
